module.exports = __webpack_public_path__ + "img/593f0b1.jpg";